import { Button } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";

import AILunaTag from "@/components/AIComponents/AILunaTag/AILunaTag";
import {
  collapseButtonCss,
  headerAndIconCss,
  headerCss,
  headingTextCss,
  taglineCss,
} from "./TeacherToolsCollapseHeader.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

interface TeacherToolsCollapseHeaderProps {
  isCollapsed: boolean;
  handleCollapse: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const TeacherToolsCollapseHeader = ({
  isCollapsed,
  handleCollapse,
}: TeacherToolsCollapseHeaderProps) => {
  return (
    <div css={headerCss}>
      <div>
        <div css={headerAndIconCss}>
          <h4 css={headingTextCss}>Apply to your lesson</h4>
          <AILunaTag />
        </div>
        <p css={taglineCss}>
          Review AI-generated suggestions for lesson content and inspiration.
        </p>
      </div>
      <ButtonWithTrackEvent
        __cssFor={{ root: collapseButtonCss }}
        {...(isCollapsed ? { actionPrefix: actionPrefixes.undo } : {})}
        actionName={actionNames.hide}
        objectType={objectTypes.quiz}
        ariaProps={{
          "aria-controls": "teacher-tools",
          "aria-expanded": !isCollapsed,
        }}
        flavor={Button.flavors.incognito}
        onClick={handleCollapse}
        data-testid="teacher-tools-collapsible"
        dataProps={{
          "data-qa-selector": `teacher_tools-${isCollapsed ? "show" : "hide"}`,
        }}
        streamProperties={{
          description: `${isCollapsed ? "Show" : "Hide"} Teacher Tools`,
        }}
      >
        {isCollapsed ? "Show" : "Hide"}
      </ButtonWithTrackEvent>
    </div>
  );
};

export default TeacherToolsCollapseHeader;
